// FREQUENTLY PRODUCT ADD TO CART
$(document).ready(function(){
  $('.frequently_product_btn').click(function(e){
    e.preventDefault();
    var product_id = $(this).attr('data_product_id');
    $.ajax({
      url: '/cart/add.js',
      type: 'POST', 
      dataType: 'json', 
      data:{quantity:1 ,id:product_id,sections:["mini-cart"]},
      success: function(data){
         fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          cartContent["sections"] = data["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: window.themeVariables.settings.cartType === "drawer"
            }
          }));
        });
      }
    });
  });


  function recommended_article() {
    $('.recommended--articles__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        infinite: true,
        arrows: true,
        prevArrow: '<button class="slide-arrow prev-arrow"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 49" class="icon icon-slider-arrow-right"><path d="M2 2l21 22.5L2 47" stroke="#484847" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 49" class="icon icon-slider-arrow-left"><path d="M23 2L2 24.5 23 47" stroke="#484847" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
            }
          }
        ]
    });
  }
  recommended_article();
  document.addEventListener("shopify:section:load", recommended_article);

  $(document).on('click', '.blog__tag_filters-item a', function(e){
    e.preventDefault();
    var href = $(this).attr('href');
    $('.blog__tag_filters-item a').removeClass('active');
    $(this).addClass('active');
    $.ajax({
      url: href,
      type: 'GET',
      dataType: 'html',
      success: function(data){
        var custom_blog_wrapper = $(data).find('.custom_blog_wrapper').html();
        $('.custom_blog_wrapper').html(custom_blog_wrapper);
        window.history.pushState(null, null, href);
        recommended_article();
      },
      error: function (xhr, ajaxOptions, thrownError) {
        if(xhr.status == 404){
          $('.custom_blog_articles').html('');
        }
      }
    })
  });


 
  $('.UpselladdToCart').click(function(e){
    e.preventDefault();
    var itemsList = [];
    var first_product_id = $(this).attr('data-product-id');
    var second_product_id = $(this).attr('data-product-id-two');
    var item = {};
    var itemtwo = {};
    item.id = first_product_id;
    item.quantity =1;    
    itemtwo.id = second_product_id;
    itemtwo.quantity = 1;
    itemsList.push(item,itemtwo);
    var data = {
      "items": itemsList
    };
    $.ajax({
      url: '/cart/add.js',
      type: 'POST', 
      dataType: 'json', 
      data:data,
      success: function(data){
         fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          cartContent["sections"] = data["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: window.themeVariables.settings.cartType === "drawer"
            }
          }));
        });
      }
    });
  });
});